import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import {isEmpty} from 'front-onceforall-core/dist/utils/arrays';
import {sortInvitations} from '../../utils/invitations';
import Invitation from './Invitation';

function SentInvitationsView(props) {
  if (props.error) {
    return (
      <span><Translate value="error.generic"/></span>
    );
  }

  const rows = sortInvitations(props.sentInvitations).map((invitation, index) => (
    <Invitation
      key={`invitation-${index}`}
      invitation={invitation}
      onRefreshRequested={props.onRefreshRequested}
      isSubcontractorView={props.isSubcontractorView}
    />
  ));

  function displayEmptyTable() {
    return (
      <div className="table-without-result">
        <Translate value="invitation.sent.noResult"/>
      </div>
    );
  }

  function displayTable() {
    return (
      <table className="two-lines">
        <thead>
          <tr>
            <td><Translate value="organisation.fullName"/></td>
            <td><Translate value="invitation.sent.email"/></td>
            <td><Translate value="invitation.sent.invitationSentDate"/></td>
            <td><Translate value="invitation.sent.status"/></td>
            <td/>
          </tr>
        </thead>
        <tbody>
          {rows}
        </tbody>
      </table>
    );
  }

  return (
    <div className="card">
      {props.loading && <div className="loading-overlay"/>}
      {isEmpty(props.sentInvitations) ?
        displayEmptyTable() : displayTable()
      }
    </div>
  );
}

SentInvitationsView.propTypes = {
  sentInvitations: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
  onRefreshRequested: PropTypes.func.isRequired,
  isSubcontractorView: PropTypes.bool
};

export default SentInvitationsView;
